(function(publish) {
    "use strict";

    function SplitText(element, options) {
        this.vars = options || {};
        this.elements = element;
        this.$el = jQuery(element);
        this.chars = [];
        this.lines = [];
        this.words = [];
        this.type = this.vars.type || "";

        this.createNodeClass = function (itemClass, itemIndex) {
            itemClass = itemClass || "";
            var isCounter = itemClass.indexOf("++") !== -1;
            if(isCounter) {
                itemClass = itemClass.replace('++', itemIndex + 1)
            }
            return itemClass;
        }

        this.isSplitChars = function () {
            return this.type.indexOf('chars') !== -1
        };

        this.isSplitWords = function () {
            return this.type.indexOf('words') !== -1
        };

        this.isSplitLines = function () {
            return this.type.indexOf('lines') !== -1
        };

        this.searchTextNodes = function(element) {
            var foundTextNodes = [];
            if (element == null || element == undefined) return foundTextNodes;
            for (var i=0; i<=element.childNodes.length-1; i++) {
                var node = element.childNodes[i];
                if (node.nodeName == "#text") { //text found
                    foundTextNodes.push(node);
                } else {
                    var foundTextNodes = foundTextNodes.concat(this.searchTextNodes(node));
                }
            }
            return foundTextNodes;
        }

        this.createElement = function(text, relatedNode, classText) {
            var node = document.createElement("div");
            var nodeText = document.createTextNode(text);
            node.nodeText = nodeText;
            node.appendChild(nodeText);
            node.style.display = "inline-block";
            node.style.position = "relative";
            node.className = classText;
            relatedNode.parentNode.insertBefore(node, relatedNode);
            return node;
        }

        this.createSpacer = function (relatedNode) {
            relatedNode.parentNode.insertBefore(document.createTextNode(' '), relatedNode);
        }

        this.splitCharacters = function(textNode) {
            var characters = textNode.nodeValue.toString();
            var chars = [];
            if (characters.trim() != "") {
                for (var c = 0; c <= characters.length - 1; c++) {
                    var character = characters.substr(c, 1)
                    var char = this.createElement(character, textNode, this.createNodeClass(this.vars.charsClass, c));
                    if (character.trim() != "") chars.push(char);
                }
                textNode.parentNode.removeChild(textNode);
            }
            return chars;
        }

        this.splitWords = function(textNode) {
            var textWords = textNode.nodeValue.toString().split(" ");
            var words = [];
            for (var w = 0; w <= textWords.length - 1; w++) {
                var textWord = textWords[w];
                var word = this.createElement(textWord, textNode, this.createNodeClass(this.vars.wordsClass, w));
                if (textWord.trim() != "") words.push(word);
                if (w < textWords.length-1) this.createSpacer(textNode); //spacing for word
            }
            textNode.parentNode.removeChild(textNode);
            return words;
        }

        this.getLineChilds = function (textNodes) {
            return this.isSplitWords() ? this.words : (this.isSplitChars() ? this.chars : textNodes);
        };

        this.splitLines = function (lineChild) {
            var lastOffset = 0, lines = [], line = [], currentLineIndex = 0, result = [], parent = lineChild[0].parentNode;
            for (var i = 0; i <= lineChild.length - 1; i++){
                var offset = lineChild[i].offsetTop + lineChild[i].getBoundingClientRect().height;
                if(offset === lastOffset) {
                    line.push(lineChild[i]);
                }
                else {
                    if(line.length > 0) lines[currentLineIndex++] = line;

                    line = [lineChild[i]];
                }
                lastOffset = offset;
            }
            lines.push(line);

            if(lineChild.length > 0) {
                for (var i = 0; i < lines.length; i++) {
                    var currentLine = $('<div class="'+this.createNodeClass(this.vars.linesClass, i)+'" style="position: relative; display: block; text-align: start"/>');
                    for (var j = 0; j < lines[i].length; j++){
                        currentLine.append(lines[i][j]);
                        currentLine.append(" ");
                    }
                    currentLine.appendTo(parent);
                    result[i] = currentLine.get(0);
                }
            }
            return result;
        };

        this.splitTextNodes = function(textNodes) {
            for (var i = 0; i <= textNodes.length - 1; i++) {
                var textNode = textNodes[i];
                if (!this.isSplitWords()) {
                    this.chars = this.chars.concat(this.splitCharacters(textNode));
                } else {
                    var words = this.splitWords(textNode);
                    if (this.isSplitChars()) {
                        for (var w = 0; w <= words.length - 1; w++) {
                            var word = words[w];
                            var chars = this.splitCharacters(word.nodeText);
                            this.chars = this.chars.concat(chars);
                            word.chars = chars;
                        }
                    }
                    this.words = this.words.concat(words);
                }

                if (this.isSplitLines()){
                    this.lines = this.splitLines(this.getLineChilds(textNode));
                }
            }
        };

        this.split = function () {
            var textNodes = this.searchTextNodes(this.$el[0]);
            this.splitTextNodes(textNodes);
        };

        this.split();
    }



    publish(SplitText);

})((typeof module == 'undefined' || (typeof window != 'undefined' && this == window))
    ? function(a) {this["SplitText"] = a;}
    : function(a) {module.exports = a;});